import { createFileRoute } from '@tanstack/react-router'

import { OnboardingPipelineScreen } from './-components/onboarding-pipeline-screen.tsx'

export const Route = createFileRoute('/merchants/onboarding-pipeline')({
  component: OnboardingPipelineScreen
})
